import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const AddCenterControlPositions = () => {
  const map = useMap();

  useEffect(() => {
    const controlContainer = map.getContainer().querySelector('.leaflet-control-container');

    const topCenter = L.DomUtil.create('div', 'leaflet-top leaflet-center', controlContainer);
    const bottomCenter = L.DomUtil.create('div', 'leaflet-bottom leaflet-center', controlContainer);

    const applyCenterStyle = (element) => {
      element.style.position = 'absolute';
      element.style.left = '50%';
      element.style.transform = 'translateX(-50%)';
    };

    applyCenterStyle(topCenter);
    applyCenterStyle(bottomCenter);

    map._controlCorners['topcenter'] = topCenter;
    map._controlCorners['bottomcenter'] = bottomCenter;
  }, [map]);

  return null;
};
export default AddCenterControlPositions;
